
import { supabase } from '@/integrations/supabase/client';

// Get user subscription status
export const getUserSubscription = async (userId: string) => {
  try {
    // Use supabase.rpc with correct typing
    const { data, error } = await supabase.functions.invoke('get-subscription', {
      body: { user_id: userId }
    });
    
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Error checking subscription status:', error);
    return null;
  }
};

// Cancel user subscription
export const cancelSubscription = async (userId: string) => {
  try {
    // Use supabase.rpc with correct typing
    const { data, error } = await supabase.functions.invoke('cancel-subscription', {
      body: { user_id: userId }
    });
    
    if (error) throw error;
    
    return true;
  } catch (error) {
    console.error('Error canceling subscription:', error);
    return false;
  }
};

// Get premium listings usage for user
export const getPremiumListingsUsage = async (userId: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('get-premium-listings-usage', {
      body: { user_id: userId }
    });
    
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Error fetching premium listings usage:', error);
    return null;
  }
};

// Get all subscription limits (listings, stock, premium listings)
export const getSubscriptionLimits = async (userId: string) => {
  try {
    const { data, error } = await supabase.functions.invoke('get-subscription', {
      body: { user_id: userId }
    });
    
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Error fetching subscription limits:', error);
    return null;
  }
};

// Admin function to get all subscriptions
export const getAllSubscriptions = async () => {
  try {
    const { data, error } = await supabase
      .from('subscriptions')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Error fetching all subscriptions:', error);
    throw error;
  }
};

// Admin function to update a subscription
export const updateSubscription = async (
  subscriptionId: string, 
  updates: { plan_id?: string; expires_at?: string; status?: string; auto_renew?: boolean }
) => {
  try {
    const { data, error } = await supabase
      .from('subscriptions')
      .update(updates)
      .eq('id', subscriptionId)
      .select()
      .single();
    
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Error updating subscription:', error);
    throw error;
  }
};

// Admin function to create a new subscription for user
export const createSubscriptionForUser = async (
  userId: string,
  planId: string,
  expiresAt: string
) => {
  try {
    // First cancel any active subscriptions
    await supabase
      .from('subscriptions')
      .update({ status: 'cancelled' })
      .eq('user_id', userId)
      .eq('status', 'active');
    
    // Create new subscription
    const { data, error } = await supabase
      .from('subscriptions')
      .insert({
        user_id: userId,
        plan_id: planId,
        status: 'active',
        expires_at: expiresAt,
        auto_renew: false
      })
      .select()
      .single();
    
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Error creating subscription for user:', error);
    throw error;
  }
};
